// Angular
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Routing
import { ChaptersRoutingModule } from './chapters-routing.module';
// Modules
import { MedsurfViewerCommonModule } from '../common/medsurf-viewer-common.module';
// Components
import { CaseStartComponent } from './main/case-start/case-start.component';
import { ChaptersComponent } from './chapters.component';
import { ChapterTextComponent } from './main/chapter-text/chapter-text.component';
import { GridComponent } from './main/grid/grid.component';
import { QuizStartComponent } from './main/quiz-start/quiz-start.component';
import { QuizEndComponent } from './main/quiz-end/quiz-end.component';
import { VocabularyComponent } from './main/vocabulary/vocabulary.component';
import { FlatDesignModule } from '@medsurf/flat-designs';

/**
 * Chapters Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    NgOptimizedImage,
    RouterModule,
    // Translate
    TranslateModule,
    // Routing
    ChaptersRoutingModule,
    // Modules
    MedsurfViewerCommonModule,
    FlatDesignModule,
  ],
  declarations: [
    // Components
    CaseStartComponent,
    ChaptersComponent,
    ChapterTextComponent,
    GridComponent,
    QuizStartComponent,
    QuizEndComponent,
    VocabularyComponent,
  ],
  exports: [
    // Components
    ChaptersComponent
  ]
})
export class ChaptersModule {
}
